<template>
	<div :class="login ? '' : 'auth-page'">
		<div :class="login ? '' : 'auth-card auth-card--wide'">
			<template v-if="!login">
				<div class="auth-logo">
					<img v-if="name.startsWith('http')" :src="name" alt="logo" />
					<span v-else class="logo-fallback">{{ name }}</span>
				</div>
				<div class="auth-badge"><i class="fas fa-user-plus"></i></div>
			</template>
			<h1 class="auth-title">Inscription</h1>
			<p class="auth-subtitle" v-if="!login">Renseignez vos informations pour créer votre compte</p>

			<div class="auth-form">
				<div class="auth-row">
					<div class="auth-field">
						<label>Prénom</label>
						<b-input class="auth-input" v-model="prenom"></b-input>
					</div>
					<div class="auth-field">
						<label>Nom</label>
						<b-input class="auth-input" v-model="nom"></b-input>
					</div>
				</div>
				<div class="auth-field">
					<label>Email</label>
					<b-input class="auth-input" type="email" v-model="email"></b-input>
				</div>
				<div class="auth-field">
					<label>Mot de passe</label>
					<b-input class="auth-input" type="password" v-model="mot_de_passe"></b-input>
					<div class="auth-hint">Minimum 8 caractères, avec au moins une majuscule, un chiffre et un caractère spécial</div>
				</div>
				<div class="auth-field" v-for="field in fields.filter(item => item.type ? true : false)" :key="field.libelle">
					<template v-if="field.type == 'list'">
						<label>{{ field.libelle }}</label>
						<b-select class="auth-input" v-model="field.result" :options="field.list"></b-select>
					</template>
					<template v-else>
						<label>{{ field.libelle }}</label>
						<b-input class="auth-input" v-model="field.result"></b-input>
					</template>
				</div>

				<b-button v-if="recaptcha_key" class="auth-submit" @click="recaptcha" variant="primary">Valider</b-button>
				<b-button v-else class="auth-submit" @click="submit" variant="primary">Valider</b-button>
			</div>

			<b-alert class="auth-alert" v-if="error" show variant="danger">{{ errorMsg }}</b-alert>
		</div>
	</div>
</template>

<script>
	import register from "../services/register.js";
	import store from "../store";

	export default {
		name: "register",
		data() {
			return {
				prenom: "",
				nom: "",
				email: "",
				mot_de_passe: "",
				token: "",
				error: false,
				errorMsg: null,
				name: process.env.VUE_APP_NAME || "Smartmydata",
				fields: [],
				recaptcha_key: process.env.VUE_APP_RECAPTCHA
			};
		},
		props: {
			_token: {
				default: "",
			},
			login: false
		},
		methods: {
			async recaptcha() {
				  await this.$recaptchaLoaded();
				  const token = await this.$recaptcha('login');

				this.submit(token);
				
					
			},
			submit(recaptcha) {
				var self = this;

				this.error = false;

				if (!this.prenom || !this.nom || !this.email || !this.mot_de_passe)
				{
					this.error = true;
					this.errorMsg =
						"Tous les champs doivent être remplis.";
					return;
				}

				if (this.token)
				{
					register
						.register(this.prenom, this.nom, this.email, this.mot_de_passe, this.token, this.fields)
						.then((res) => {

							this.$notify({
								group: "info",
								title: "Compte créé, un mail vous a été envoyé pour l'activer",
								type: "success",
							});

							if (self._token)
								this.$emit('register')
							else
								this.$router.push({ name: "login" });
						})
						.catch((err) => {
							this.error = true;
							this.errorMsg = err;
						});
				}
				else
				{
					register
						.register_client(this.prenom, this.nom, this.email, this.mot_de_passe, recaptcha)
						.then((res) => {

							this.$notify({
								group: "info",
								title: "Compte créé, un mail vous a été envoyé pour l'activer",
								type: "success",
							});

							if (self._token || self.login)
								this.$emit('register')
							else
								this.$router.push({ name: "login" });
						})
						.catch((err) => {
							this.error = true;
							this.errorMsg = err;
						});
				}
			},
		},
		async destroyed() {
			const recaptcha = this.$recaptchaInstance
			recaptcha.hideBadge()
		},
		async mounted()
		{
			const recaptcha = this.$recaptchaInstance
			recaptcha.showBadge()

			this.token = this._token || this.$route.params.token;

			if (this.token)
			{
				this.fields = await register.register_get(this.token);
				this.fields = this.fields.fields;
			}
			
			for (var i = 0; i < this.fields.length; i++)
			{
				if (!this.fields[i].result)
					this.fields[i].result = "";
			}
		}
	};
</script>

